// Custom TSW Js
/*
function updateAvailabilityFilterTsw(){
    var $ = jQuery;

    // First check if this is collections page
    var isCollections = $('body').hasClass('template-collection');

    if ( isCollections ) {
        // check how many Size selectors are checked
        var sizeSelections = $('[name="filter.v.option.select a size"]').length;
        var isAvailabilitySelected = false;

        // Check if an availability is already selected
        if ( 
            jQuery('#Filter-Availability-1').prop('checked') ||
            jQuery('#Filter-Availability-2').prop('checked')
        ) {
            isAvailabilitySelected = true;
        }

        if ( sizeSelections > 0 && !isAvailabilitySelected ) {
            $('#Filter-Availability-1').trigger('click');
        } else {
            console.log('Size collection not selected ' , sizeSelections, ' or Availability already selected.', isAvailabilitySelected);
        }
    }
}


document.addEventListener('DOMContentLoaded', function(){
  jQuery( document ).ready(function(){        
        jQuery('body').on('click', '[name="filter.v.option.select a size"]', function(e){
            console.log('test');
            window.setTimeout(function(){
                updateAvailabilityFilterTsw();
            }, 300);
        });
    });
});
*/

/*
function updateAvailabilityFilterTsw(){
    var $ = jQuery;

    // First check if this is collections page
    var isCollections = $('body').hasClass('template-collection');

    if ( isCollections ) {
        // check how many Size selectors are checked
        var sizeSelections = $('[name="filter.v.option.select a size"]').length;
        var isAvailabilitySelected = false;

        // Check if an availability is already selected
        if ( 
            jQuery('#Filter-Availability-1').prop('checked') ||
            jQuery('#Filter-Availability-2').prop('checked')
        ) {
            isAvailabilitySelected = true;
        }

        if ( sizeSelections > 0 && !isAvailabilitySelected ) {
            $('#Filter-Availability-1').trigger('click');
        } else {
            console.log('Size collection not selected ' , sizeSelections, ' or Availability already selected.', isAvailabilitySelected);
        }
    }
}



         console.log('TSW - jQuery on ready');
        jQuery('body').on('change', '[name="filter.v.option.select a size"]', function(e){
            console.log('test');
            window.setTimeout(function(){
                updateAvailabilityFilterTsw(e);
            }, 300);
        });
    });
*/
   jQuery( document ).ready(function($){
  console.log("Live theme");
 setTimeout(function() {
    $('.rbr-addBundleBtn-container.rbr-centralize.rbr-cursor-pointer span').text('Add bundle to cart');
    $(".singleSelectBox_select_763bfe94 option:first-child").text("Select Size");
  }, 3000);
// console.log("Duplicate theme end");

  }); 



function updateAvailabilityFilterTsw() {
    // First check if this is collections page
    var isCollections = document.body.classList.contains('template-collection');

    if (isCollections) {
        // check how many Size selectors are checked
        var sizeSelections = document.querySelectorAll('[name="filter.v.option.select a size"]').length;
        var isAvailabilitySelected = false;

        // Check if an availability is already selected
        if (document.getElementById('Filter-Availability-1').checked || document.getElementById('Filter-Availability-2').checked) {
            isAvailabilitySelected = true;
        }

        if (sizeSelections > 0 && !isAvailabilitySelected) {
            document.getElementById('Filter-Availability-1').click();
        } else {
            console.log('Size collection not selected', sizeSelections, 'or Availability already selected.', isAvailabilitySelected);
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('TSW - vanilla JS on ready');
    document.body.addEventListener('change', function (e) {
        if (e.target.getAttribute('name') === 'filter.v.option.select a size') {
            console.log('test');
            setTimeout(function () {
                updateAvailabilityFilterTsw(e);
            }, 300);
        }
    });
});


/*
function updateAvailabilityFilterTsw(e) {
  // First check if this is the collections page
  var isCollections = document.body.classList.contains('template-collection');

  if (isCollections) {
    // Check how many Size selectors are checked
    var sizeSelections = document.querySelectorAll('[name="filter.v.option.select a size"]').length;
    var isAvailabilitySelected = false;

    // Check if an availability is already selected
    if (
      document.getElementById('Filter-Availability-1').checked ||
      document.getElementById('Filter-Availability-2').checked
    ) {
      isAvailabilitySelected = true;
    }

    if (sizeSelections > 0 && !isAvailabilitySelected) {
      document.getElementById('Filter-Availability-1').checked = true;
      document.getElementById('Filter-Availability-1').click();
    } else {
      console.log(
        'Size collection not selected ',
        sizeSelections,
        ' or Availability already selected.',
        isAvailabilitySelected
      );
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    if (e.target.getAttribute('name') === 'filter.v.option.select a size') {
      console.log('test');
      setTimeout(function () {
        updateAvailabilityFilterTsw(e);
      }, 300);
    }
  });
});
*/

// Disable slide cart on live theme
window.SLIDECART_OPENED = function() {
  // Fires whenever Slide Cart has been opened
  window.SLIDECART_CLOSE();
}



/*
* Default Cart Function
*/
$(document).on('submit', '.mini-cart ', function(e){
  handleFloCheckoutBtn();
  e.preventDefault();
});

// corner disabled cart change
function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
}

function getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
}
function updateCartHtml(){
  const sections = getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line:0,
      quantity:1,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {//console.log(state)
                         const parsedState = JSON.parse(state);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    setTimeout(function(){
        getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
      }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
                     if(jQuery('.cart-drawer-container.menu-opening').length<1){    $('#cart-icon-bubble ').click()}
                       })
}

function updateCartSectionsHtmlOld(id,qty){
  console.log('####section updates##')
  const sections = getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      id:id,
      quantity:qty,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${window.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {//console.log(state)
                         const parsedState = JSON.parse(state);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    setTimeout(function(){
        getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
      }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
                     if(jQuery('.cart-drawer-container.menu-opening').length<1){    $('#cart-icon-bubble ').click()}
                       })
}

$(document).on('click', '.atcBtn', function(e){
  
  console.log("UFE")
   updateCartHtml()
});




// NEW PAGE ACCORDION BUTTON

document.addEventListener("DOMContentLoaded", function () {
  initAccordions();
  function initAccordions() {
    var container = document.querySelector(".faqs-deepSleep .product-details");
    if (!container) return;
    if (container.querySelector(".accordion-toggle-btn")) return;

    var accordions = container.querySelectorAll("accordion-tab");
    if (accordions.length <= 3) return;

    // Hide accordions after the 3rd
    for (var i = 3; i < accordions.length; i++) {
      accordions[i].style.display = "none";
    }

    // Create button
    var button = document.createElement("button");
    button.innerText = "VIEW ALL FAQS";
    button.className = "accordion-toggle-btn";

    // Insert button
    accordions[2].after(button);

    button.addEventListener("click", function () {

      // Show all accordions
      for (var i = 3; i < accordions.length; i++) {
        accordions[i].style.display = "";
      }

      // Hide the button permanently
      button.style.display = "none";
    });
  }

  // Nudge the color slider of feature collection new section
 // Nudge the color slider of feature collection new section
function nudge(track){
  track.style.transition = 'transform 0.6s ease';
  track.style.transform = 'translateX(-25px)';

  setTimeout(()=>{
    track.style.transform = 'translateX(0)';
  },600);
}

// Select ONLY the first slider
const slider = document.querySelector('[data-featured-collection-color-slider]');

if(slider){
  const track = slider.querySelector('.featured-collection-card-color-slider__track');

  setTimeout(()=>{
    setInterval(()=>{
      nudge(track);
    },4000); // every 4 seconds
  },2000); // start after 2 seconds
}
});

